<template>
  <div class="mt2">
    <span class="mr2 full-height align-top">Appliquer une réduction ?</span>
    <SwitchComponent v-model="applyPromo" />
    <div v-if="applyPromo">
      <div class="col-12 flex flex-wrap">
        <div v-for="metric in discountMetrics" :key="metric.value" class="col-12 md-col-6 flex flex-wrap my2">
          <div class="col-2">
            <div :class="['flex mr2 full-height pointer']">
              <span :class="['custom-radio flex', { 'selected-item': isSelected(metric.value) }]" @click="selectMetric(metric.value)"></span>
            </div>
          </div>
          <div class="col-10 flex items-center">
            <span>{{ metric.label }}</span>
          </div>
        </div>
      </div>
      <p v-if="selectedMetric === 'euro'" class="mb0">Mensualité</p>
      <input
        v-model="promoAmount"
        type="number"
        class="mt1 col-12 py1 h4n px2"
        :placeholder="selectedMetric === 'euro' ? 'a reduction is an amount' : 'a reduction is a %'"
        :required="true"
        onwheel="return false"
        @keydown="keyPressed"
      >
      <div v-if="isSubscriptionTDA" class="col-12 mt2 mb3">
        <span class="mr2">Récurrente ?</span>
        <SwitchComponent v-model="applyRecurringPromo" />
      </div>
      <p v-if="selectedMetric === 'euro'" class="mb0">Remise sur le premier paiement (ex : frais de dossier)</p>
      <input
        v-if="fee > 0 && selectedMetric === 'euro'"
        v-model="promoAmountFee"
        type="number"
        class="my1 col-12 py1 h4n px2"
        placeholder="a reduction is an amount"
        :required="true"
        onwheel="return false"
        @keydown="keyPressed"
      >
      <span v-if="priceError" class="h5 block col-12 alert no-box red mt2 cgiError">
        <i class="mt2 icon h5 mr2 ml1 red icon-stop"></i>Le montant de la réduction doit être inférieur au montant de la commande
      </span>
      <div class="col-12 mt2">
        <span>Motif:</span>
        <div class="md-flex lg-flex">
          <div v-for="motive in discountMotives" :key="motive.value" class="col-12 md-col-4 flex flex-wrap my2">
            <div class="col-2">
              <div :class="['flex mr2 full-height pointer']">
                <span :class="['custom-radio flex cust-min-width', { 'selected-item': isMotiveSelected(motive.value) }]" @click="selectMotive(motive.value)"></span>
              </div>
            </div>
            <div class="col-10 flex items-center">
              <span>{{ motive.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchComponent from '@/components/elements/Switch.vue';

export default {
  components: { SwitchComponent },
  props: {
    recurringPrice: {
      type: String,
      default: ''
    },
    fee: {
      type: String,
      default: ''
    },
    totalPriceCart: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      applyPromo: false,
      promoAmount: null,
      promoAmountFee: null,
      selectedMetric: null,
      selectedMotive: null,
      discountMetrics: [
        { label: 'euro (€)', value: 'euro' },
        { label: 'pourcentage (%)', value: 'percentage' }
      ],
      discountMotives: [
        { label: 'Plusieurs enfants', value: 'secondChild' },
        { label: 'Personnel UCPA', value: 'staff' },
        { label: 'Geste commercial', value: 'commercial' },
        { label: 'Autre', value: 'other' }
      ],
      applyRecurringPromo: false
    };
  },
  computed: {
    feeHasError () {
      if (this.promoAmountFee && this.selectedMetric) {
        const discount = parseFloat(this.promoAmountFee);
        switch (this.selectedMetric) {
          case 'euro': {
            const price = parseFloat(this.fee);
            return discount < 0 || discount > price;
          }
          default:
            return false;
        }
      }
      return false;
    },
    priceHasError () {
      if (this.promoAmount && this.selectedMetric) {
        const discount = parseFloat(this.promoAmount);
        switch (this.selectedMetric) {
          case 'euro': {
            const price = parseFloat(this.isSubscriptionTDA ? this.recurringPrice : this.totalPriceCart);
            return discount < 0 || discount > price;
          }
          case 'percentage': {
            return discount < 0 || discount > 100;
          }
          default:
            return false;
        }
      }
      return false;
    },
    isSubscriptionTDA () {
      return this.$store.state.subscriptionTDA;
    },
    priceError () {
      return this.isSubscriptionTDA ? this.feeHasError || this.priceHasError : this.priceHasError;
    }
  },
  watch: {
    priceError: function (newVal) {
      this.$store.commit('setFormValid', !newVal);
    },
    applyPromo: function (newVal, _oldVal) {
      this.$emit('applyPromo', newVal);
      if (!newVal) {
        this.promoAmount = null;
        this.selectedMetric = null;
        this.$store.commit('setPromoCampaign', null);
      }
    },
    promoAmount: function (newVal, _oldVal) {
      this.$store.commit('setPromoAmount', newVal);
      this.$emit('discountAmount', newVal);
    },
    promoAmountFee: function (newVal, _oldVal) {
      this.$store.commit('setPromoAmountFee', newVal);
      this.$emit('discountAmountFee', newVal);
    },
    selectedMetric: function (newVal, _oldVal) {
      this.$store.commit('setPromoMetric', newVal);
      this.$emit('discountMetric', newVal);
    },
    applyRecurringPromo: function (newVal, _oldVal) {
      this.$store.commit('setRecurringPromo', newVal);
    },
    selectedMotive: function (newVal, _oldVal) {
      this.$emit('discountMotive', newVal);
    }
  },
  methods: {
    isSelected (value) {
      return this.selectedMetric === value;
    },
    selectMetric (value) {
      this.selectedMetric = value;
    },
    keyPressed (e) {
      return e.keyCode === 38 || e.keyCode === 40 ? e.preventDefault() : null;
    },
    selectMotive (value) {
      this.selectedMotive = value;
    },
    isMotiveSelected (value) {
      return this.selectedMotive === value;
    }
  }
};

</script>

<style lang="scss" scoped>
  .cgiError{
    font-size: 14px;
  }
</style>
